'use strict';

var HostLadderListDirective = function HostLadderListDirective() {
  return {
    restrict: 'E',
    replace: true,
    controller: 'HostLadderListController',
    template: require('../templates/host-ladder-list.html'),
    scope: {
      screenState: '=',
      dataDimension: '=dimension'
    }
  };
};
HostLadderListDirective.$inject = [];
module.exports = HostLadderListDirective;